import { usePageMeta } from "@/hooks/usePageMeta";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import NewsSection from "@/pages/home/components/NewsSection";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  usePageMeta(
    "国产久久久—最新国产影片资源与影视资讯平台",
    "国产久久久网站专注于提供丰富的国产影视作品内容，涵盖电影、电视剧等多种题材，满足用户影视资讯及内容浏览需求。",
    "国产久久久,国产影视,国产电影,国产电视剧,影视资讯,影视资源,影视平台"
  );

  return (
    <div className="w-full">
      <HeroCarousel />
      <FeaturedSection />
      <CategoryEntries />
      <NewsSection />
      <SiteIntro />
    </div>
  );
}